import { request } from '@umijs/max';
import type { BaseResponse } from './service.d';

/** 当前商家账号修改密码请求参数 */
export interface MerchantAccountChangePasswordParams {
  oldPassword: string;
  newPassword: string;
  rePassword: string;
}

/**
 * 当前商家账号修改密码
 * PUT /api/v1/merchant-accounts/me/password
 */
export async function changeCurrentAccountPassword(
  data: MerchantAccountChangePasswordParams,
) {
  return request<BaseResponse<void>>('/api/v1/merchant-accounts/me/password', {
    method: 'PUT',
    data: {
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
      rePassword: data.rePassword,
    },
  });
}
